import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { logoutUserAPI } from '../../api/userDashboardApis/user-dashboard.api';

export const useUserLogout = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = async () => {
    setIsLoggingOut(true); // 👈 FIXED: Corrected spelling here
    try {
      // 1. Tell backend to clear the HTTP-only cookie
      await logoutUserAPI();
      
      // 2. Clear frontend storage (only user data, protecting expert data)
      localStorage.removeItem('user_code');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_email');
      localStorage.removeItem('userName'); // 🟢 ADDED
      localStorage.removeItem('userProfileImage'); // 🟢 ADDED
      
      // 3. Navigate away to the correct route
      toast.success('Logged out successfully');
      navigate('/user-login'); 
      
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if API fails, clear specific user local storage and force redirect
      localStorage.removeItem('user_code');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_email');
      localStorage.removeItem('userName'); // 🟢 ADDED
      localStorage.removeItem('userProfileImage'); // 🟢 ADDED
      
      navigate('/user-login'); 
      
    } finally {
      setIsLoggingOut(false);
    }
  };

  return { logout, isLoggingOut };
};